import * as Configuration from '../../../app.constants.js';

WhatsappConnectController.$inject = ['$scope', 'TopToolbarFactory', '$http', '$stateParams', 'company', 'AlertingFactory', '$state'];
export function WhatsappConnectController($scope, TopToolbarFactory, $http, $stateParams, company, AlertingFactory, $state) {
    $scope.submit = submit;
    init();

    function submit() {
        $scope.isSubmitDisabled = true;
        let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + company.id + '/sites';
        $http.post(url, {
            authorization_id: $stateParams.authId,
            type: 'whatsapp'
        }).then(function success(response) {
            $state.go('auth.alcmeon.fuse.parameters.account.whatsapp-pre-verify', {siteId: response.data.id});
        }, function error(response) {
            AlertingFactory.alertHTTPError(response);
            $scope.isSubmitDisabled = false;
        });
    }

    function init() {
        $scope.isSubmitDisabled = false;
        TopToolbarFactory.setTitleTranslation('add-account/whatsapp', $scope);
    }
}
